<template>
    <div class="space-y-3">
        <div class="px-1">
            <p class="text-lg font-bold text-slate-900">Mode de signature</p>
            <p class="text-sm text-slate-500 mt-0.5">Comment le client souhaite-t-il signer les documents ?</p>
        </div>

        <!-- Sur place -->
        <button
            class="w-full flex items-center gap-4 bg-white border border-gray-200 hover:border-blue-300 rounded-2xl px-4 py-4 transition-colors text-left"
            @click="wm.currentStep = 'signature'"
        >
            <div class="w-12 h-12 bg-blue-50 rounded-2xl flex items-center justify-center shrink-0">
                <svg class="w-6 h-6 text-blue-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="flex-1">
                <p class="font-semibold text-slate-800">Signer maintenant</p>
                <p class="text-xs text-slate-400 mt-0.5">Le client signe directement sur l'écran</p>
            </div>
            <svg class="w-5 h-5 text-slate-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6" stroke-linecap="round"/></svg>
        </button>

        <!-- Par email -->
        <button
            class="w-full flex items-center gap-4 bg-white border border-gray-200 hover:border-blue-300 rounded-2xl px-4 py-4 transition-colors text-left"
            @click="wm.currentStep = 'signature-email'"
        >
            <div class="w-12 h-12 bg-orange-50 rounded-2xl flex items-center justify-center shrink-0">
                <svg class="w-6 h-6 text-orange-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                </svg>
            </div>
            <div class="flex-1">
                <p class="font-semibold text-slate-800">Signature par email</p>
                <p class="text-xs text-slate-400 mt-0.5">Un lien de signature est envoyé au client</p>
            </div>
            <svg class="w-5 h-5 text-slate-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6" stroke-linecap="round"/></svg>
        </button>
    </div>
</template>

<script>
export default {
    name: 'StepSignatureType',
    inject: ['wm'],
};
</script>
